import { render, staticRenderFns } from "./CampaignsListPage.vue?vue&type=template&id=93c88098&"
import script from "./CampaignsListPage.vue?vue&type=script&lang=js&"
export * from "./CampaignsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports